import { HttpService } from "services";
import { User } from "types/entities";

import {
  UpdateProfilePictureFunction,
  UpdateProfilePictureFunctionParams,
} from "types/functions";
import { AuthorizationLevel } from "types/http";

/**
 * Retrieve detailed information about listing
 *
 * @throws {HttpServiceException}
 */
export const updateUserProfilePicture: any = async (formData: any) => {
  try {
    const url = `/user/profile-picture/upload`;

    // Make the API request
    const res: any = await HttpService.fetch(
      url,
      {
        requestConfig: {
          method: "POST",
          data: formData,
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return res;
  } catch (error) {
    throw error;
  }
};
